import { check } from "@xams-utils/check-types";

const isValidMessage = (message) => {
    const emptyMessage = ["MESSAGE UNDEFINED", "MESSAGE_UNDEFINED"];
    return (
        check.nonEmptyString(message) && emptyMessage.indexOf(message) === -1
    );
};

const getActualAdvocateAppId = (integrityAdvocateAppId, iAAppType) => {
    if (check.nonEmptyString(integrityAdvocateAppId)) {
        const appIds = integrityAdvocateAppId.split(",");

        if (appIds.length > 0) {
            if (check.number(iAAppType) && iAAppType < appIds.length) {
                return appIds[iAAppType];
            }

            return appIds[0];
        }
    }
    
    return integrityAdvocateAppId;
};

export { isValidMessage, getActualAdvocateAppId };
